import React from 'react';
import PropTypes from 'prop-types';
import { includes, isEmpty } from 'ramda';
import { useFormContext } from 'react-hook-form';
import { ControlledSelect } from '@@viewCommonComponents/controlled';
import { isRequiredSelect } from '@@viewHelpers/validations/index.js';

export const commissionRateIsDisplayed = ({
  getMiddleBoolean,
  usersInformation,
  rates
}) =>
  getMiddleBoolean('PROCESSDEVENTE_TAUX_COMMISSION_EST_NECESSAIRE') &&
  includes('BROKER', usersInformation?.[0]?.roles ?? []) &&
  !isEmpty(rates ?? []);

const CommissionRateSelector = ({ rates, getMiddleText }) => {
  const form = useFormContext();

  return (
    <div className={'w-full flex flex-row mb-2 justify-end'}>
      <div className={'w-40'}>
        <ControlledSelect
          name={'commission'}
          form={form}
          rules={isRequiredSelect(rates)}
          options={rates}
          label={getMiddleText('PROCESSDEVENTE_TAUX_COMMISSION_LABEL')}
          withIndicator={false}
          data-testid="commissionRate"
        />
      </div>
    </div>
  );
};

CommissionRateSelector.propTypes = {
  rates: PropTypes.array,
  getMiddleText: PropTypes.func
};

export default CommissionRateSelector;
